const state = {
    businessIncomeTotals: []
}

const getters = {
    businessIncomeTotals: state => state.businessIncomeTotals,
}

const mutations = {
    saveBusinessIncomeTotals: (state, totals) => {
      state.businessIncomeTotals = totals
    },
}

const actions = {
    saveBusinessIncomeTotals: (context, totals) => {
      context.commit("saveBusinessIncomeTotals", totals)
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
